import React, { useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ContextProvider } from '../globalContextProvider';

export default function CustomSnackBar() {
  const { visibleSnackBar } = useContext(ContextProvider);
  const notifyExited = (error) => {
    toast(error, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  }

  const notifyEntered = (success) => {
    toast(success, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  }

  React.useEffect(() => {
    if (visibleSnackBar.value) {
      if (visibleSnackBar.action === "ENTRY") {
        notifyEntered(`${visibleSnackBar.vehicle_number} has entered`)
      } else {
        notifyExited(`${visibleSnackBar.vehicle_number} has exited`)
      }
    }
  }, [visibleSnackBar])

  return (
    <div>
      <ToastContainer position="bottom-right"
        autoClose={10000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        icon={false}
        toastStyle={{ color: visibleSnackBar.action === "ENTRY" ? "#18cc69" : "##de575e" }}
      />
    </div>
  );
}